import React, { useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import {
    Collapse,
    NavbarBrand,
    Navbar,
    NavItem,
    NavLink,
    Nav,
    Container,
    Row,
    Col,
} from "reactstrap";

const Sidebar = (props) => {
    const [collapseOpen, setCollapseOpen] = useState();
    // toggles collapse between opened and closed (true/false)
    const toggleCollapse = () => {
        setCollapseOpen((data) => !data);
    };
    // closes the collapse
    const closeCollapse = () => {
        setCollapseOpen(false);
    };
    // creates the links that appear in the left menu / Sidebar
    const createLinks = (routes) => {
        return routes.map((prop, key) => {
            return (
                <NavItem key={key}>
                    <NavLink
                        to={prop.path}
                        tag={NavLinkRRD}
                        onClick={closeCollapse}
                        activeClassName="active"
                    >
                        {prop.icon ? <i className={prop.icon} /> : ""}
                        {prop.pageName}
                    </NavLink>
                </NavItem>
            );
        });
    };

    const { routes } = props;
    const visibleRoutes = routes.filter(r => !r.hidden);

    return (
        <Navbar
            className="navbar-vertical fixed-left navbar-light bg-white"
            expand="md"
            id="sidenav-main">
            <Container fluid>
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}>
                    <span className="navbar-toggler-icon" />
                </button>
                <NavbarBrand className="pt-0" href="/">
                    <div className="logo logo-blue logo-center-center"></div>
                </NavbarBrand>
                <Collapse navbar isOpen={collapseOpen}>
                    <div className="navbar-collapse-header d-md-none">
                        <Row>
                            <Col className="collapse-brand" xs="6">
                                <Link to="/" className="logo logo-blue"></Link>
                            </Col>
                            <Col className="collapse-close" xs="6">
                                <button
                                    className="navbar-toggler"
                                    type="button"
                                    onClick={toggleCollapse}
                                >
                                    <span />
                                    <span />
                                </button>
                            </Col>
                        </Row>
                    </div>
                    <Nav navbar>{createLinks(visibleRoutes)}</Nav>
                    <hr className="my-3" />
                    <Nav navbar>
                        <NavItem>
                            <NavLink
                                to="/logout"
                                tag={NavLinkRRD}
                                onClick={closeCollapse}
                                activeClassName="active">
                                <i className="fas fa-sign-out-alt"></i>
                                Sign out
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Container>
        </Navbar>
    );
};

export default Sidebar;
